import React, { useState, useEffect } from "react";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import StepBreadcrumb from "./step-breadcrumb";
import moment from "jalali-moment";
import IsLogin from "../../utilities/functions/isLogin";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ConfirmAppointment = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  const doctorID = localStorage.getItem("doctor_id");
  const eventDate = localStorage.getItem("selectedDay");
  const eventHour = localStorage.getItem("selectedHour");
  const doctorFirstName = localStorage.getItem("doctor_first_name");
  const doctorLastName = localStorage.getItem("doctor_last_name");
  const departmentName = localStorage.getItem("department_name");
  const placeName = localStorage.getItem("place_name");
  const address = localStorage.getItem("address");

  // selected variables
  const [city, setCity] = useState({ id: null, name: null });
  const place = localStorage.getItem("place_id");
  const department = localStorage.getItem("department_id");
  const [doctor, setDoctor] = useState({
    id: null,
    first_name: null,
    last_name: null,
  });

  // personal information
  const [firstName, setFirstName] = useState("تست");
  const [lastName, setLastName] = useState("تست زاده");
  const [phoneNumber, setPhoneNumber] = useState("09910192070");

  const [visitType, setVisitType] = useState();

  const getUserInfo = () => {
    setLoading(true);

    axios
      .get(
        serverConfig.server.url + apiConfig.api.userControllers.getUserInfo,
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setFirstName(response.data.data.first_name);
          setLastName(response.data.data.last_name);
          setPhoneNumber(response.data.data.mobile);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const convertToMiladi = (input) => {
    const miladiMoment = moment(input, "jYYYY/jMM/jDD");
    const miladiDateFormatted = miladiMoment.format("YYYY/MM/DD");
    return miladiDateFormatted;
  };

  const setEventAPI = () => {
    setLoading(true);

    axios
      .post(
        serverConfig.server.url + apiConfig.api.publicAPIs.setEvent,
        {
          doctor_id: doctorID,
          place_id: place,
          department_id: department,
          guest_details: {
            first_name: firstName,
            last_name: lastName,
            mobile: phoneNumber,
          },
          start: convertToMiladi(eventDate) + " " + eventHour,
          type: "in_person",
        }
        // { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      if (loggedIn === false || loggedIn === "error api") {
        // localStorage.clear();
        localStorage.getItem("FullName") && localStorage.removeItem("FullName");
        localStorage.getItem("mobile") && localStorage.removeItem("mobile");
        localStorage.getItem("token") && localStorage.removeItem("token");
        localStorage.setItem(
          "callBackURL",
          window.location.pathname + window.location.search
        );
        navigate("/login");
      }
    };

    checkLoginStatus();
  }, []);

  return (
    <div>
      <StepBreadcrumb step={2}></StepBreadcrumb>
      <h5 className="color-bootstrap-gray-600">تایید اطلاعات</h5>
      <div className="d-flex row gy-3">
        {/* Cards */}

        {/* Reference details form card */}
        <div className="col-12 px-0">
          <div className="card card-box-shadow">
            <div className="card-header">{eventDate}</div>
            <div className="card-body d-flex row">
              <div className="col col-lg-6 col-12">
                <div className="d-flex">
                  <p className="fs-14 fw-medium">
                    {firstName + " " + lastName}
                  </p>
                </div>
                <div className="d-flex">
                  <p className="me-1">تلفن :</p>
                  <p>{phoneNumber}</p>
                </div>
                <div className="d-flex">
                  <p className="me-1">نوع ویزیت :</p>
                  <p>حضوری</p>
                </div>
              </div>

              <div className="col col-lg-6 col-12 fs-14 fw-medium">
                <div className="d-flex">
                  <p>
                    {doctorFirstName} {doctorLastName}
                  </p>
                </div>
                <div className="d-flex">
                  <p className="me-1">مرکز درمانی : {placeName}</p>
                </div>
                <div className="d-flex">
                  <p>دپارتمان : {departmentName}</p>
                </div>
                <div className="d-flex">
                  <p>آدرس : {address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 mt-5 px-0 d-flex">
          <div className="pe-2 col-6">
            <div className="btn btn-primary w-100" onClick={setEventAPI}>
              تایید نهایی
            </div>
          </div>
          <div className="ps-2 col-6">
            <div
              className="btn btn-gray w-100"
              onClick={() => {
                navigate(-1); // go to back (history)
              }}
            >
              بازگشت
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAppointment;
